{
  "close": "Κλείσιμο",
  "notifications": "Ειδοποιήσεις"
}
